import { Injectable } from '@angular/core';
import {
  DownloadFileOptions,
  DownloadFileResult,
  Filesystem,
  ReadFileOptions,
  ReadFileResult,
} from '@capacitor/filesystem';

@Injectable({
  providedIn: 'root',
})
export class FileSystemService {
  downloadFile(options: DownloadFileOptions): Promise<DownloadFileResult> {
    return Filesystem.downloadFile(options);
  }

  readFile(options: ReadFileOptions): Promise<ReadFileResult> {
    return Filesystem.readFile(options);
  }
}
